import * as React from "react";
import type { SVGProps } from "react";
const SvgPerformance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      stroke="#757575"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10 3.167v3.333m0 8.333v3.334M16.667 10.5h-3.334m-6.666 0H3.333"
    />
    <path
      stroke="#757575"
      strokeWidth={1.5}
      d="M10 14.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
    />
    <path
      stroke="#757575"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10 10.5L7.5 8"
    />
  </svg>
);
export default SvgPerformance;